import { render, staticRenderFns } from "./AegCommissionSplit.vue?vue&type=template&id=b2ee8b8c"
import script from "./AegCommissionSplit.vue?vue&type=script&lang=js"
export * from "./AegCommissionSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports